module.exports = __webpack_public_path__ + "img/alflorex_packshot-1.a4838138.png";